import {LoggedUser} from 'app/_interfaces/logged-user';
import {DocumentationEntryAuthor} from 'app/_models/model/documentationEntryAuthor';

export const authorFromUser = (user: LoggedUser): DocumentationEntryAuthor => ({
	name: user.name,
	authorId: user.guid,
	initials: user.initials,
	professionId: user.profession
});
